import { render, staticRenderFns } from "./FormElementExample.vue?vue&type=template&id=a83874e8&scoped=true&"
import script from "./FormElementExample.vue?vue&type=script&lang=js&"
export * from "./FormElementExample.vue?vue&type=script&lang=js&"
import style0 from "./FormElementExample.vue?vue&type=style&index=0&id=a83874e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83874e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
